<template>
  <!-- Home Layout -->
  <!-- <div class="container-page parent-home home-layout"> -->
  <div class="container-page parent-home index-layout">
    <!-- Left Layout -->
    <div class="side-layout left-layout" id="leftFixed">
      <!-- Daily home -->
      <div class="child-content">
        <div class="balloon-hint balloon-bottom-left">
          <p>Monitor kehadiran anak Anda setiap hari di sini. Pastikan anak Anda melakukan pindai wajah (face recognition) / pindai jari (fingerprint scanning) pada mesin presensi yang tersedia di sekolah setiap kali anak Anda tiba di sekolah dan saat anak Anda meninggalkan sekolah.</p>
        </div>

        <DailyHome @detail-click="detailClickWeek" @search-period="modalSetPeriod = true" :prop-filter="valueDailyObject" />
      </div>

      <!-- Comboard priority -->
      <div class="child-content">
        <!-- <div class="balloon-hint balloon-bottom-left"> -->
          <!-- <p>Monitor kehadiran anak Anda setiap hari di sini. Pastikan anak Anda melakukan pindai wajah (face recognition) / pindai jari (fingerprint scanning) pada mesin presensi yang tersedia di sekolah setiap kali anak Anda tiba di sekolah dan saat anak Anda meninggalkan sekolah.</p> -->
        <!-- </div> -->

        <div class="header-child header-green">
          Comboard Priority
        </div>

        <div class="content-base">
          <div class="solo-list">
            <div class="inner-list" v-for="item in comboardsPriority.value" :key="item" @click="showPriority(item.id)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Center Layout -->
    <div class="main-layout">
      <!-- Mobile Greeting Hero -->
      <div class="greeting-hero">
        <div class="profile-pict">
          <img src="@/assets/parent/user-icon-r.png" />
        </div>

        <div class="greeting-text">
          <p>Hi, <span>{{ userLogin }}</span></p>
          <p>{{ usernameLogin }}</p>
        </div>
      </div>

      <MobileHalf :comboard-priority="comboardsPriority.value" @click-priority="showPriority" />

      <!-- Comboard -->
      <div class="admin-comboard-container display-comboard-container">
        <div class="comboard-container">
          <div class="comboard-content">
            <!-- Comboard skelaton loading -->
            <div v-if="loadingComboard === true">
              <div class="comboard-skelaton-loading" v-for="data in 4" :key="data">
                <div class="loading-header">
                  <div class="loading-bar loading-bar-big" />
                  <div class="loading-bar" />
                  <div class="loading-bar" />
                </div>

                <div class="loading-body">
                  <div class="loading-container" />
                  <div class="loading-container loading-container-big" />
                </div>
              </div>
            </div>

            <!-- Comboard Container -->
            <div class="comboard-card" v-for="(item, indexx) in comboards.value" :key="indexx">

              <!-- Header comboard -->
              <div class='header-comboard-card' @click="detailInfo(item.id)">
                <!-- Header icon -->
                <div class="header-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-if="item.is_recalled === true" :class="item.is_recalled === true ? 'danger-icon' : ''">
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-else>
                    <path d="M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"/>
                  </svg>
                </div>

                <!-- Header information -->
                <div class="header-text">
                  <!-- Title comboard -->
                  <div class="title-comboard" :title="item.title">
                    <p :class="item.is_recalled === true ? 'title-danger' : ''">{{ item.title }}</p>
                  </div>

                  <!-- Subtitle comboard -->
                  <div class="subtitle-comboard">
                    <p class="post-name">{{ item.creator }}</p>
                    <p class="post-date">{{ formatHalfMonth(item.datetime_1) }}{{ ' - ' + formatHalfMonth(item.datetime_2) }}</p>
                    <p class="post-recall" v-if="item.is_recalled === true" @click="showReason(item.id)">Recalled</p>
                  </div>
                </div>
              </div>

              <!-- Content comboard -->
              <div class="content-comboard-card">
                <!-- Second title for mobile -->
                <div class="second-title">
                  {{ item.title }}
                </div>

                <!-- Information comboard -->
                <div class="info-comboard" :class="(openText == item.id) ? 'open-info' : 'hide-info'">
                  <span v-html="item.info" />

                  <div class="show-info" @click="showText(item.id)">
                    <p>{{ (openText == item.id) ? 'Less' : 'Show more' }}</p>
                  </div>
                </div>

                <!-- Download file -->
                <div class="file-comboard" v-if="item.file_1">
                  <div class="file-container" v-if="item.file_1.length != 0">
                    <div class="file-content" v-for="file_data in item.file_1" :key="file_data" @click="download(file_data.file, '/download-comboard', item.id)" :title="file_data.file">
                      <div class="file-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                        </svg>
                      </div>

                      <div class="file-name">
                        <p>{{ file_data.file }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Carousel video & photo -->
                <div class="carousel-comboard" v-if="(item.link_url != null )|| (item.link_url != undefined) || (item.file_img.length != 0)">
                  <Carousel :mouse-drag="false" :touch-drag="false">
                    <Slide v-if="(item.link_url != null ) || (item.link_url != undefined)">
                      <LazyYoutube
                        ref="youtubeLazyVideo"
                        :src="item.link_url"
                        thumbnail-quality="standard"
                      />
                    </Slide>

                    <Slide v-for="image in item.file_img" :key="image" v-show="(item.file_img.length != 0)" style="cursor: pointer;">
                      <img :src="image" alt="Comboard picture" @click="openImg(image, '')">
                    </Slide>

                    <template #addons>
                      <Navigation/>
                      <Pagination/>
                    </template>
                  </Carousel>
                </div>
              </div>

              <!-- Comment Section -->
              <div class="comment-wrapper">
                <div class="mb-5">
                  <span>Leave comment</span>
                  <!-- <span class="look-comment">See Comments ({{ commentParent.value.filter(value => value.comboard_id === item.id).length + commentParent.value.filter(value => value.detail_id === value.id).length }}) </span> -->
                </div>

                <div class="h-0" v-if="commentParent.value.filter(value => value.comboard_id === item.id).length === 0"></div>

                <!-- Parent Comment -->
                <div class="scroll-comment" v-else>
                  <li v-for="item_header in commentParent.value.filter(value => value.detail_id === null && value.comboard_id === item.id)" :key="item_header">
                    <!-- Comment Container -->
                    <div class="block-comment">
                      <span class="created-text">{{ item_header.name }}</span>
                      <span v-html="item_header.comment"></span>
                    </div>

                    <!-- Action Comment -->
                    <div class="mb-2.5">
                      <div class="flex">
                        <span class="created_at">{{ item_header.created_at }}</span>
                        <span>.</span>
                        <span class="reply" @click="showid(item_header.id, item_header.reply)">Reply</span>

                        <!-- More Action Plus Comment For Delete -->
                        <div class="merge-container" @click="deletePostComment(item_header.id)" v-if="(item_header.created_by === usernameLogin) || (checkUser === true)">
                          <p class="dot">.</p>
                          <span class="text-delete">Delete</span>
                        </div>
                      </div>

                      <!-- Child Comment -->
                      <li v-for="item_head_detail in parentChild.value.filter(value => value.head_id === item_header.id)" :key="item_head_detail">
                        <div :style="'margin-left: '+(parseInt(item_head_detail.reply)-1)*30+'px;'">

                          <div class="flex">
                            <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                                <rect width="40" height="50" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_101_7)">
                                <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                              </g>
                            </svg>
                            <div class="block-comment">
                              <span class="created-text"> {{ item_head_detail.name }} </span>
                              <span>{{ item_head_detail.comment }}</span>
                            </div>
                          </div>

                          <!-- Action Comment -->
                          <div class="mb-2.5">
                            <div class="swipe">
                              <span class="created_at">{{ item_header.created_at }}</span>
                              <span>.</span>
                              <span class="reply" @click="showdetailid(item_head_detail.id, item_head_detail.reply, item_header.id)">Reply</span>

                              <!-- More Action Plus Comment For Delete -->
                              <div class="merge-container" @click="deletePostComment(item_head_detail.id)" v-if="(item_head_detail.created_by === usernameLogin) || (checkUser === true)">
                                <p class="dot">.</p>
                                <span class="text-delete">Delete</span>
                              </div>
                            </div>
                          </div>

                          <!-- Input Parent > Child First -->
                          <form @submit.prevent="store2(item_head_detail.id, item.id)" class="pb-3 pr-4 ml-7 z-10 dark:shadow-gray-200" v-if="comboards.show_detail_id===item_head_detail.id">
                            <div class="flex">
                              <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                                  <rect width="40" height="50" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_101_7)">
                                  <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                                </g>
                              </svg>

                              <div class="reply-chat flex w-full">
                                <input class="input-comment" :key="index" v-model="parentChild.comment_detail[item_head_detail.id]">
                                <jb-button
                                  :icon="mdiSend"
                                  small
                                  class="button-submit"
                                  color="success"
                                  type="submit"
                                  id="submit">
                                </jb-button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </li>

                      <!-- Add Child Comment -->
                      <div v-if="comboards.show_id===item_header.id">
                        <!-- Input Parent > Child Second -->
                        <form @submit.prevent="store2(item_header.id, item.id)" class="pb-3 pr-4 z-10 dark:shadow-gray-200">
                          <div class="flex">
                            <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                                <rect width="40" height="50" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_101_7)">
                                <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                              </g>
                            </svg>

                            <div class="reply-chat flex w-full">
                              <input class="input-comment" :key="index" v-model="parentChild.comment_detail[item_header.id]">
                              <jb-button
                                :icon="mdiSend"
                                small
                                class="button-submit"
                                color="success"
                                type="submit"
                                id="submit">
                              </jb-button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </li>
                </div>

                <!-- Input Comment Parent -->
                <form @submit.prevent="store(item.id, indexx)" :id="'comboardlistid' + indexx" class="space-y-3 pb-3 z-10 dark:shadow-gray-200">
                  <div>
                    <textarea v-model="commentParent.comment_input[indexx]" :placeholder="'Type Your Comment On Here'" type="text"></textarea>
                    <jb-button
                      label="Submit"
                      :icon="mdiSend"
                      small
                      class="button-submit"
                      color="success"
                      type="submit"
                      id="submit">
                    </jb-button>
                  </div>
                </form>
              </div>

              <!-- <div class="comboard-content" :id="'comboardlistid'+indexx">
                <accordion>
                  <template v-slot:title>
                    <div class='header-comboard'>
                      <div class="top-header">
                        <div class="balloon-hint balloon-top-left">
                          <p>Jadilah yang pertama dalam menerima informasi penting berkaitan dengan kegiatan-kegiatan sekolah melalui menu ini.<br>Anda juga dapat mengunduh file-file yang dibagikan oleh sekolah dengan klik / tap pada file.</p>
                        </div>

                        <div class="left-header">
                          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M70.8333 158.333H66.6666C33.3333 158.333 16.6666 150 16.6666 108.333V66.6666C16.6666 33.3333 33.3333 16.6666 66.6666 16.6666H133.333C166.667 16.6666 183.333 33.3333 183.333 66.6666V108.333C183.333 141.667 166.667 158.333 133.333 158.333H129.167C126.583 158.333 124.083 159.583 122.5 161.667L110 178.333C104.5 185.667 95.5 185.667 90 178.333L77.5 161.667C76.1666 159.833 73.0833 158.333 70.8333 158.333Z" stroke="black" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M133.3 91.6666H133.383M99.9583 91.6666H100.042M66.625 91.6666H66.6917" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>

                        <div class="center-header">
                          <div class='com-title'><span v-html="item.title"/></div>
                          <div class='com-date'>
                            <span v-if="item.show_date <= dateYes && item.show_date >= dateNow">{{ formatTime(item.show_date) }}</span>
                            <span v-if="item.show_date < dateNow && item.show_date > dateWeek">{{ formatDay(item.show_date) }}</span>
                            <span v-if="item.show_date < dateWeek">{{ formatFullDate(item.show_date) }}</span>
                          </div>
                          <div class="subtitle">
                            <div class="created_by">{{ item.created_by }}<span v-if="(item.datetime_1 && item.datetime_2) !== null"> | </span></div>

                            <div class="flex items-center justify-center" v-if="item.is_recalled === true">
                              <span class="reason recalled" @click="showReason(item.id)">Recalled</span>

                              <div class="modal-recall shape-chat" v-if="showModalReason === item.id">
                                <span> {{ item.reason }}</span>
                              </div>
                            </div>

                            <div class='date' v-if="(item.datetime_1 && item.datetime_2) !== null">
                              <span v-if="(formatMonth(item.datetime_2) === formatMonth(item.datetime_1)) && (formatDateMonth(item.datetime_2) === formatDateMonth(item.datetime_1))">{{ item.event_end_time }}</span>
                              <span v-if="(formatMonth(item.datetime_2) === formatMonth(item.datetime_1)) && (formatDateMonth(item.datetime_2) !== formatDateMonth(item.datetime_1))">{{ formatDate(item.datetime_1) }} - {{ formatFullDate(item.datetime_2) }}</span>
                              <span v-if="(formatMonth(item.datetime_2) !== formatMonth(item.datetime_1))">{{ formatDateMonth(item.datetime_1) }} - {{ formatHalfMonth(item.datetime_2) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="desc-comboard">
                        <div class="inner-desc" :class="longText === item.id ? 'long-text' : 'short-text'">
                          <p>
                            <span v-html="item.info" />
                          </p>
                        </div>
                        <span class="short-desc" @click="showDesc('test')" v-if="longText === item.id">lihat lebih sedikit</span>
                        <span v-else class="short-desc" @click="showDesc(item.id)">lihat lebih banyak...</span>
                      </div>

                      <div class="asset-comboard">
                        <div v-if="item.link_url === null || item.link_url === undefined || item.link_url === 0 || item.link_url === ''"></div>
                        <div v-else>
                          <LazyYoutube
                            :src=item.link_url
                            class="tumbnail"
                          />
                        </div>

                        <div class="image-comboard">
                          <div class="img-scroll">
                            <div v-if="item.file_img == 0"></div>
                            <div class="image-content" v-for="image in item.file_img" :key="image" v-else>
                              <show-image :imageName="image" @click="comboards.modalMore = item.id" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="menu-comboard">
                        <button @click="openComment(item)">
                          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M153.917 140.25L157.167 166.583C158 173.5 150.583 178.333 144.667 174.75L109.75 154C105.917 154 102.167 153.75 98.5 153.25C104.816 145.928 108.304 136.587 108.333 126.917C108.333 103.25 87.8333 84.0833 62.5 84.0833C52.8333 84.0833 43.9166 86.8333 36.5 91.6666C36.25 89.5833 36.1666 87.5 36.1666 85.3333C36.1666 47.4166 69.0833 16.6666 109.75 16.6666C150.417 16.6666 183.333 47.4166 183.333 85.3333C183.333 107.833 171.75 127.75 153.917 140.25Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M108.333 126.917C108.333 136.833 104.667 146 98.5 153.25C90.25 163.25 77.1666 169.667 62.5 169.667L40.75 182.583C37.0833 184.833 32.4166 181.75 32.9166 177.5L35 161.083C23.8333 153.333 16.6666 140.917 16.6666 126.917C16.6666 112.25 24.5 99.3334 36.5 91.6667C43.9166 86.8334 52.8333 84.0834 62.5 84.0834C87.8333 84.0834 108.333 103.25 108.333 126.917Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          Comment
                          <span class="look-comment">({{ commentParent.value.filter(value => value.comboard_id === item.id).length + commentParent.value.filter(value => value.detail_id === value.id).length }}) </span>

                          <div class="balloon-hint balloon-bottom-right">
                            <p>Silakan tinggalkan pesan di sini bila Anda memiliki pertanyaan kepada pihak sekolah.</p>
                          </div>
                        </button>
                      </div>

                      <div v-if="item.file_1.length == 0"></div>
                      <div v-else class="pdf-home">
                        <div class="pdf-content">
                          <div class="pdf-value" v-for="file_data in item.file_1" :key="file_data">
                            <show-image :imageName="file_data.file" @click="download(file_data.file, '/download-comboard', item.id)" />
                            <div class="text-pdf" @click="download(file_data.file, '/download-comboard', item.id)">
                              <p>{{ file_data.file }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </accordion>
              </div> -->
            </div>
            <div class="comboard-card" v-if="!comboards.value">
              <!-- Header information -->
              <div class="header-text">
                  <!-- Title comboard -->
                   <p class="text-center"> No Data.</p>
              </div>
            </div>
            <!-- Show more button -->
            <div class="more-button" style="margin-bottom: 40px;" v-if="comboards.value">
              <button class="button-all-action button-all-primary" @click="filterData()">
                <span>Show more</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- right Layout -->
    <div class="side-layout right-layout" id="rightFixed">
      <!-- Invoice home -->
      <div class="child-content">
        <div class="balloon-hint balloon-bottom-right">
          <p>Daftar tagihan yang masih perlu Anda lunasi. Silakan hubungi Keuangan Sekolah bilamana terdapat data yang belum sesuai.</p>
        </div>

        <invoice-home @detail-click="detailClickInv" />
      </div>

      <!-- Payment home -->
      <div class="child-content">
        <div class="balloon-hint balloon-top-right">
          <p>Daftar transaksi pembayaran yang telah Anda lakukan. Pastikan Anda membayar tagihan sesuai dengan nomor Virtual Account yang diberikan oleh pihak sekolah.</p>
        </div>

        <payment-home @detail-click="detailClickPay" />
      </div>
    </div>
  </div>

  <!-- Whatsapp link -->
  <whatsapp-link />

  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
  </div>

  <!-- Delete pop up -->
  <div class="del-popup" :class="modDelPick === true ? 'mod-del-show' : 'mod-del-hide'">
    <div class="del-container">
      <div class="header-del">
        <p>Warning!</p>
        <p>{{ messDel }}</p>
        <p>Are you sure you want to remove <span class="urgent">this</span> comment?</p>
      </div>
      <div class="del-action">
        <div class="btn-del-con" @click="confirm">
          Confirm
        </div>
        <div class="btn-del-cen" @click="modDelPick = false">
          Cancel
        </div>
      </div>
    </div>
  </div>

  <!-- Modal comboard detail -->
  <div class="modal-comboard" :class="modalComboard === true ? 'show-comboard' : 'hide-comboard'">
    <div class="asset-more">
      <div class="asset-comboard">
        <div class="btn-np" v-if="dataCom.file_img">
          <div class="btn-round" :class="thisCar === 0 ? 'btn-hide' : ''" @click="btnPrevCar(1, dataCom.file_img)">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M125 166L70.6666 111.667C64.25 105.25 64.25 94.75 70.6666 88.3333L125 34" stroke="white" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="btn-round" :class="thisCar === (-dataCom.file_img.length) ? 'btn-hide' : ''" @click="btnNextCar(-1, dataCom.file_img)">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M74.25 166L128.583 111.667C135 105.25 135 94.75 128.583 88.3333L74.25 34" stroke="white" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="carousel-base">
          <div class="carousel-container" :style="cssVars">
            <div v-if="dataCom.link_url === null || dataCom.link_url === undefined || dataCom.link_url === 0 || dataCom.link_url === ''"></div>
            <div v-else>
              <LazyYoutube
                :src="dataCom.link_url"
                class="tumbnail"
              />
            </div>

            <div class="scroll-image">
              <div class="cover-image" v-for="image in dataCom.file_img" :key="image">
                <show-image :imageName="image" @click="comboards.modalMore = dataCom.id" />
              </div>
            </div>
          </div>

          <div class="dots-nav">
            <div class="dot-content" :class="thisCar === 0 ? 'dot-active' : ''"></div>
            <div v-for="image, index in dataCom.file_img" :key="image" class="dot-content" :class="thisCar === (-index - 1) ? 'dot-active' : ''"></div>
          </div>
        </div>

        <div class="pdf-container">
          <div class="pdf-box">
            <div class="pdf" v-for="file_data in dataCom.file_1" :key="file_data">
              <show-image :imageName= "file_data.file" @click="download(file_data.file, '/download-comboard', item.id)" />
              <div class="text-pdf" @click="download(file_data.file, '/download-comboard', item.id)">
                <p>File name:</p>
                <p>{{ file_data.file }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="more-action" v-if="commentParent.value">
          <div class="mobile-comment" @click="modalChat = true">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M153.917 140.25L157.167 166.583C158 173.5 150.583 178.333 144.667 174.75L109.75 154C105.917 154 102.167 153.75 98.5 153.25C104.816 145.928 108.304 136.587 108.333 126.917C108.333 103.25 87.8333 84.0833 62.5 84.0833C52.8333 84.0833 43.9166 86.8333 36.5 91.6666C36.25 89.5833 36.1666 87.5 36.1666 85.3333C36.1666 47.4166 69.0833 16.6666 109.75 16.6666C150.417 16.6666 183.333 47.4166 183.333 85.3333C183.333 107.833 171.75 127.75 153.917 140.25Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M108.333 126.917C108.333 136.833 104.667 146 98.5 153.25C90.25 163.25 77.1666 169.667 62.5 169.667L40.75 182.583C37.0833 184.833 32.4166 181.75 32.9166 177.5L35 161.083C23.8333 153.333 16.6666 140.917 16.6666 126.917C16.6666 112.25 24.5 99.3334 36.5 91.6667C43.9166 86.8334 52.8333 84.0834 62.5 84.0834C87.8333 84.0834 108.333 103.25 108.333 126.917Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Comment
            <span class="look-comment">({{ commentParent.value.filter(value => value.comboard_id === dataCom.id).length + commentParent.value.filter(value => value.detail_id === value.id).length }}) </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Comment section -->
    <div class="comment-more comment-mobile" :class="modalChat === true ? ' com-mob-act' : 'com-mob-hide'">
      <div class="header-comment">
        <span v-if="commentParent.value">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M153.917 140.25L157.167 166.583C158 173.5 150.583 178.333 144.667 174.75L109.75 154C105.917 154 102.167 153.75 98.5 153.25C104.816 145.928 108.304 136.587 108.333 126.917C108.333 103.25 87.8333 84.0833 62.5 84.0833C52.8333 84.0833 43.9166 86.8333 36.5 91.6666C36.25 89.5833 36.1666 87.5 36.1666 85.3333C36.1666 47.4166 69.0833 16.6666 109.75 16.6666C150.417 16.6666 183.333 47.4166 183.333 85.3333C183.333 107.833 171.75 127.75 153.917 140.25Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M108.333 126.917C108.333 136.833 104.667 146 98.5 153.25C90.25 163.25 77.1666 169.667 62.5 169.667L40.75 182.583C37.0833 184.833 32.4166 181.75 32.9166 177.5L35 161.083C23.8333 153.333 16.6666 140.917 16.6666 126.917C16.6666 112.25 24.5 99.3334 36.5 91.6667C43.9166 86.8334 52.8333 84.0834 62.5 84.0834C87.8333 84.0834 108.333 103.25 108.333 126.917Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Comment
          <span class="look-comment">({{ commentParent.value.filter(value => value.comboard_id === dataCom.id).length + commentParent.value.filter(value => value.detail_id === value.id).length }}) </span>
        </span>

        <span class="close-desk" @click="modalComboard = false">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76.4168 123.583L123.583 76.4167M123.583 123.583L76.4168 76.4167M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 100 16.6667C54.1668 16.6667 16.6667 54.1667 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>

        <span class="close-mobile" @click="modalChat = false">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76.4168 123.583L123.583 76.4167M123.583 123.583L76.4168 76.4167M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 100 16.6667C54.1668 16.6667 16.6667 54.1667 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>
      <div class="comment-modal" style="padding: 0 0;" v-if="commentParent.value">
        <div class="more-message">
          <li class="main-message" v-for="item_header in commentParent.value.filter(value => value.detail_id === null && value.comboard_id === dataCom.id)" :key="item_header">
            <div class="comment-chat">
              <div class="comment-by">{{ item_header.name }}</div>
              <div class="comment-mess"><span class="reply-name">{{ item_header.reply_name }}</span><span v-html="item_header.comment" /></div>
              <div class="comment-time">{{ forDate(item_header.created_at) }}</div>
            </div>

            <div class="reply-comment">
              <div class="action-comment">
                <span class="reply-text" @click="showid(item_header.id, item_header.reply)">Reply</span>&ensp;
                <span class="delete-text"  @click="deletePostComment(item_header)" v-if="item_header.created_by===usernameLogin || userCheck.value">Delete</span>
              </div>

              <!-- Child Comment -->
              <li v-for="(item_head_detail) in parentChild.value.filter(value => value.head_id === item_header.id)" :key="item_head_detail">
                <div :style="'margin-left: '+(parseInt(item_head_detail.reply))*30+'px;'">
                <!-- <div class="space-left"> -->
                  <div class="reply-chat">
                    <div class="comment-chat">
                      <div class="comment-by">{{ item_head_detail.name }}</div>
                      <div class="comment-mess"><span class="reply-name">{{ item_head_detail.reply_name }}</span>&nbsp;<span v-html="item_head_detail.comment" /></div>
                      <div class="comment-time">{{ forDate(item_head_detail.created_at) }}</div>
                    </div>
                  </div>

                  <div class="reply-comment">
                    <div class="action-comment">
                      <span class="reply-text" @click="showdetailid(item_head_detail.id, item_head_detail.reply, item_header.id)">Reply</span>&ensp;
                      <span class="delete-text" @click="deletePostComment(item_head_detail)" v-if="item_head_detail.created_by===usernameLogin || userCheck.value">Delete</span>
                    </div>
                  </div>

                  <!-- Input Child 1 -->
                  <form @submit.prevent="store2(item_head_detail.id, dataCom.id)" v-if="comboards.show_detail_id===item_head_detail.id">
                    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
                    <div class="reply-chat">
                      <input class="input-form" placeholder="Type your comment..." :key="index" v-model="parentChild.comment_detail[item_head_detail.id]">
                      <button type="submit">
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M45.3333 100H90.3333M79.25 35.25L150.583 70.9167C182.583 86.9167 182.583 113.083 150.583 129.083L79.25 164.75C31.25 188.75 11.6667 169.083 35.6667 121.167L42.9167 106.75C44.75 103.083 44.75 97 42.9167 93.3334L35.6667 78.8334C11.6667 30.9167 31.3333 11.25 79.25 35.25Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                  </form>
                </div>
              </li>

              <!-- Input Child 2 -->
              <div v-if="comboards.show_id===item_header.id">
                <form class="space-bottom" @submit.prevent="store2(item_header.id, dataCom.id)">
                  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
                  <div class="reply-chat">
                    <input class="input-form" placeholder="Type your comment..." :key="index" v-model="parentChild.comment_detail[item_header.id]">
                    <button type="submit">
                      <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M45.3333 100H90.3333M79.25 35.25L150.583 70.9167C182.583 86.9167 182.583 113.083 150.583 129.083L79.25 164.75C31.25 188.75 11.6667 169.083 35.6667 121.167L42.9167 106.75C44.75 103.083 44.75 97 42.9167 93.3334L35.6667 78.8334C11.6667 30.9167 31.3333 11.25 79.25 35.25Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </li>
        </div>

        <div class="more-column-comment">
          <form @submit.prevent="store(dataCom.id, indexx)">
            <div class="column-text">
              <textarea v-model="inputComment.comment_input[indexx]" placeholder="Type your comment..."></textarea>

              <button type="submit">
                <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M45.3333 100H90.3333M79.25 35.25L150.583 70.9167C182.583 86.9167 182.583 113.083 150.583 129.083L79.25 164.75C31.25 188.75 11.6667 169.083 35.6667 121.167L42.9167 106.75C44.75 103.083 44.75 97 42.9167 93.3334L35.6667 78.8334C11.6667 30.9167 31.3333 11.25 79.25 35.25Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="close-comboard" @click="modalComboard = false" />
  </div>

  <!-- Modal week -->
  <div class="modal-add" :class="modalWeek === true ? 'show-form-add' : 'hide-form-add'">
    <div class="close-modal" @click="modalWeek = false"></div>
    <modal-week :prop-detail="detailObject" @close-click="closeClick" />
  </div>

  <!-- Modal invoice -->
  <div class="modal-add" :class="modalInv === true ? 'show-form-add' : 'hide-form-add'">
    <div class="close-modal" @click="modalInv = false"></div>
    <modal-inv :prop-detail="detailObject" @close-click="closeInv" />
  </div>

  <!-- Modal payment -->
  <div class="modal-add" :class="modalPay === true ? 'show-form-add' : 'hide-form-add'">
    <div class="close-modal" @click="modalPay = false"></div>
    <modal-pay :prop-detail="detailObject" @close-click="closePay" />
  </div>

  <!-- Set Period -->
  <div class="modal-add"  :class="modalSetPeriod === true ? 'show-form-add' : 'hide-form-add'">
    <div class="close-modal" @click="modalSetPeriod = false"></div>

    <div class="content-modal">
      <!-- Header Modal -->
      <div class="header-modal">
        Set Period

        <div class="btn-close" @click="modalSetPeriod = false">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76.4168 123.583L123.583 76.4166M123.583 123.583L76.4168 76.4166M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1666 145.833 16.6666 100 16.6666C54.1668 16.6666 16.6667 54.1666 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Form modal -->
      <div class="form-modal">
        <form @submit.prevent="mySubmitFunction(event)">
          <div class="row-input">
            <!-- Input student -->
            <div class="half-input">
              <div class="title-input">Start Date</div>
              <input type="date" v-model="valueDaily.firstWeek">
            </div>

            <!-- Auto relation class -->
            <div class="half-input">
              <div class="title-input">End Date</div>
              <input type="date" v-model="valueDaily.lastWeek" :min="valueDaily.firstWeek">
            </div>
          </div>

          <!-- Button action form -->
          <div class="buttons-action min-button" :class="modalSetPeriod === true ? '' : 'buttons-sticky'">
            <button @click="modalSetPeriod = false">Cancel</button>
            <button @click="searchPeriod()">
              Search
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal show image -->
  <div class="modal-image" :class="openImgDetail == true ? 'open-modal-image' : 'hide-modal-image'">
    <div class="close-image" @click="openImg()"/>

    <div class="prev-image">
      <div class="close-btn" @click="openImg()">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M76.4168 123.583L123.583 76.4166M123.583 123.583L76.4168 76.4166M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1666 145.833 16.6666 100 16.6666C54.1668 16.6666 16.6667 54.1666 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <img v-if="dataImgDetail.img" :src="dataImgDetail.img" :alt="dataImgDetail.alt ? dataImgDetail.alt : ''" />
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import Three from '@/components/Three'
  import LazyYoutube from '@/components/LazyYoutube'
  import JbButton from '@/components/JbButton'
  import axios from 'axios'
  import { axiosDocument } from '@/boot/axios'
  import Accordion from '@/components/Accordion'
  import { mdiMenuDown, mdiClose, mdiSend, mdiCircleSmall, mdiArrowDownDropCircle } from '@mdi/js'
  import { ref, reactive, onMounted, onBeforeMount, watchEffect, computed, onUpdated, defineComponent } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import { useToast } from 'vue-toastification'
  import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel'
  import 'vue3-carousel/dist/carousel.css'
  import Loading from 'vue-loading-overlay'
  import ShowImage from '@/components/ShowImage'
  import ShowImage2 from '@/components/showImage2'
  import 'vue-loading-overlay/dist/vue-loading.css'
  // import Carousel from '@/views/comboards/comboard/Carousel.vue'
  import DailyHome from './Home/DailyHome.vue'
  import SubjectHome from './Home/SubjectHome.vue'
  import InvoiceHome from './Home/InvoiceHome.vue'
  import PaymentHome from './Home/PaymentHome.vue'
  import MobileHalf from './Home/MobileHalf.vue'
  import dayjs from 'dayjs'
  import WhatsappLink from '@/components/ParentView/WhatsappLink.vue'
  import ModalWeek from '@/components/ParentView/daily/ModalDetail.vue';
  import ModalInv from '@/components/ParentView/invoice/ModalDetail.vue';
  import ModalPay from '@/components/ParentView/payment/ModalDetail.vue';

  export default defineComponent ({
    name: 'HomeSection',
    components: {
      JbButton,
      Accordion,
      Loading,
      LazyYoutube,
      ShowImage,
      DailyHome,
      SubjectHome,
      InvoiceHome,
      PaymentHome,
      ShowImage2,
      Three,
      WhatsappLink,
      MobileHalf,
      ModalWeek,
      ModalInv,
      ModalPay,
      Carousel,
      Pagination,
      Slide,
      Navigation
    },

    props: {
      imageName: String,
      comment: Object,
      showEdit: { Boolean },
      src: {
        type: String,
        required: true
      },
      oembedFetch: {
        type: Boolean,
        default: true,
        required: false
      },
      propHome: {
        type: Object,
        default: () => ({ empty: true })
      },
      propClass: {
        type: Object,
        default: () => ({ empty: true })
      },
      propChild: {
        type: Object,
        default: () => ({ empty: true })
      },
      propAttach: {
        type: Object,
        default: () => ({ empty: true })
      }
    },

    data() {
      return {
        currentIndex: 0,
        slideCount: null
      }
    },

    methods: {
      // Format IDR (2.000.000)
      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    emits: ['close-modal', 'submit'],

    setup (props, { emit }) {
      const image = computed(() => props.imageName ? props.imageName : '' )
      const idValueComment = ref()
      const idValueChild = ref()
      const isLoading = ref(true)
      const homeObject = ref({})
      const childObject = ref({})
      const childModal = ref({})
      const str = useStore()
      const toast = useToast()
      const errors = ref([])
      const router = useRouter()
      const userLogin = localStorage.getItem('name')
      const userRole = localStorage.getItem('roles')
      const usernameLogin = localStorage.getItem('username')
      const detailModal = ref(false)
      const detailChild = ref(false)
      const titleStack = ref(['Admin', 'Forms'])
      const slides = reactive([])
      const commentClickId = ref()
      const deleteComboards = ref()
      const loadingComboard = ref(false)

      // Modal function
      const modalWeek = ref(false)
      const detailObject = ref();
      const detailClickWeek = (event) => {
        detailObject.value = event
        if (modalWeek.value) {
          modalWeek.value = false
        } else {
          modalWeek.value = true
        }
      }
      const closeClick = (event, item) => {
        if (modalWeek.value) {
          modalWeek.value = false
        } else {
          modalWeek.value = true
        }
      }

      const modalInv = ref(false)
      const detailClickInv = (event) => {
        detailObject.value = event
        if (modalInv.value) {
          modalInv.value = false
        } else {
          modalInv.value = true
        }
      }
      const closeInv = (event, item) => {
        if (modalInv.value) {
          modalInv.value = false
        } else {
          modalInv.value = true
        }
      }

      const modalPay = ref(false)
      const detailClickPay = (event) => {
        detailObject.value = event
        if (modalPay.value) {
          modalPay.value = false
        } else {
          modalPay.value = true
        }
      }
      const closePay = (event, item) => {
        if (modalPay.value) {
          modalPay.value = false
        } else {
          modalPay.value = true
        }
      }

      const modDelPick = ref(false)
      const datadel = ref()
      const messDel = ref()
      const deletePostComment = (value) => {
        modDelPick.value = true
        datadel.value = value
        messDel.value = value.comment
        // showModal()
        comboards.detail_delete = 'comment'
      }
      const deleteModal = ref(false)
      const hideModal = () => {
        deleteModal.value = false
        refresh2()
      }
      const showModal = () => {
        deleteModal.value = !deleteModal.value
      }
      const confirm = () => { confirmDeleteComment() }

      const checkUser = ref(false)
      const userCheck = () => {
        const myArray = userRole.split(',')
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
            checkUser.value = true
          }
        }
      }

      const cancel = () => (deleteModal.value = false)

      const confirmDeleteComment = () => {
      isLoading.value = true
      const url = 'deletecomment'
      const method = 'POST'
      axios({
            method,
            url,
            params: {
              id: datadel.value
            }
          })
      .then(response => {
        if (response.data.success) {
          modDelPick.value = false
          isLoading.value = false
          toast.success(response.data.message, { timeout: 5000 })
          refresh2()
        } else {
          isLoading.value = false
          toast.error(response.data.message, { timeout: 5000 })
        }
        }).catch(error => {
          isLoading.value = false
          console.log(error)
        })
      }

      const dataReason = ref(false)
      const showModalReason = ref('test')
      const showReason = (index) => {
        dataReason.value = index
        if(showModalReason.value !== index){
          showModalReason.value = index
        } else {
          showModalReason.value = 'test'
        }
      }

      const comboards = reactive({
        id: '',
        show_date: '',
        comboard_category_id: '',
        info: '',
        is_event: '',
        datetime_1: '',
        datetime_2: '',
        to_parent: '',
        to_student: '',
        to_teacher: '',
        add_to_calendar: '',
        is_recalled: '',
        recall_time: '',
        reason: '',
        created_by: '',
        updated_by: '',
        link_url: '',
        show_id: '',
        show_detail_id: '',
        detail_delete: '',
        skip: 0,
        page: 1,
        checkpage: 1,
        modalMore: ''
      })

      const reset = () => {
        inputComment.comment_input = []
      }

      const filterData = () => {
        comboards.skip = 5 * comboards.page
        comboards.page = comboards.page + 1
        refresh()
      }

      const showComp = ref(true)

      const inputComment = reactive({
        id: '',
        name: '',
        comment: '',
        comment_input: [],
        comboard_id: '',
        created_by: '',
        updated_by: ''
      })
      const commentParent = reactive({
        id: '',
        show_date: '',
        comboard_category_id: '',
        info: '',
        is_event: '',
        datetime_1: '',
        datetime_2: '',
        to_parent: '',
        to_student: '',
        to_teacher: '',
        add_to_calendar: '',
        is_recalled: '',
        recall_time: '',
        reason: '',
        name: '',
        comment: '',
        comment_input: [],
        created_by: '',
        updated_by: '',
        created_at: ''
      })
      const comment2 = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        created_by: '',
        updated_by: ''
      })
      // Child
      const parentChild = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        comment_detail: [],
        reply_detail: [],
        reply_head: [],
        name: '',
        created_by: '',
        updated_by: '',
        detail_id: ''
      })

      const parentChild2 = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        created_by: '',
        updated_by: '',
        detail_id: ''
      })

      // Parent
      let rowData = []
      const refresh = () => {
        isLoading.value = true
        loadingComboard.value = true
        const user_parent = localStorage.getItem('user_id')
        const loginAs = 'parent'
        const url = 'comboard-parent'
        const method = 'GET'
        axios({
          method,
          url,
          params: {
            user_parent_id: user_parent,
            login_as: loginAs,
            skip: comboards.skip
          }
        })
        .then(response => {
            if (comboards.skip < 1) {
              commentParent.value = response.data.dataDetail
              parentChild.value = response.data.dataDetail
            }

            if(response.data.data.length>0){
              const jdiSatu = [...rowData, ...response.data.data]
              rowData = jdiSatu
              comboards.value = rowData
            }
            showComp.value = false
            isLoading.value = false

            comboards.checkpage = response.data.checkisi
            if(comboards.checkpage<1){
              alert('Semua data sudah ditampilkan')
            }
            isLoading.value = false
            loadingComboard.value = false
        })
        .catch(error => {
          loadingComboard.value = false
          refreshDoc()
          console.log(error)
        })
      }
      const refreshDoc = () => {
        isLoading.value = true
        const user_parent = localStorage.getItem('user_id')
        const loginAs = 'parent'
        const url = 'comboard-parent'
        const method = 'GET'
        axiosDocument({
          method,
          url,
          params: {
            user_parent_id: user_parent,
            login_as: loginAs,
            skip: comboards.skip
          }
        })
        .then(response => {
            if (comboards.skip < 1) {
              commentParent.value = response.data.dataDetail
              parentChild.value = response.data.dataDetail
            }

            if(response.data.data.length>0){
              const jdiSatu = [...rowData, ...response.data.data]
              rowData = jdiSatu
              comboards.value = rowData
            }
            showComp.value = false
            isLoading.value = false

            comboards.checkpage = response.data.checkisi
            if(comboards.checkpage<1){
              alert('Semua data sudah ditampilkan')
            }
            isLoading.value = false
        })
        .catch(error => {
          isLoading.value = false
          console.log(error)
        })
      }

      // Download File
      const download = (name, url, id) => {
        // UNCOMMENT JIKA EDU TIDAK MENGGUNKAKAN DOC-MANAGEMENT
        const data = {
          filename: name,
          id: id
        }
        axios
          .get(url, {
            params: data,
            responseType: 'blob'
          })
          .then((response) => {
            // assign state kelass with response data
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', name)
            document.body.appendChild(fileLink)
            fileLink.click()
          })
          .catch((error) => {
            // toast.error(error.response.data, { timeout: 5000 })
            // downloadDoc(name, url, id)
            console.log(error)
          })
      }
      const downloadDoc = (name, url, id) => {
        // UNCOMMENT JIKA EDU MENGGUNKAKAN DOC-MANAGEMENT
        const data = {
          filename: name,
          id: id
        }
        axiosDocument
          .get('download-comboard', {
            params: data,
            responseType: 'blob'
          })
          .then((response) => {
            // assign state kelass with response data
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', name)
            document.body.appendChild(fileLink)
            fileLink.click()
          })
          .catch((error) => {
            // toast.error(error.response.data, { timeout: 5000 })
            console.log('ERROR', error)
          })
      }

      // Detail
      const refresh2 = () => {
        isLoading.value = false
        const user_parent = localStorage.getItem('user_id')
        const url = 'comment-parent'
        const method = 'GET'
        axios({
          method,
          url,
          params: {
            user_parent_id: user_parent,
            comboard_id: idValueComment.value
          }
        })
        .then(response => {

          commentParent.value = response.data.data
          // Child
          parentChild.value = response.data.data
          isLoading.value = false
        })
        .catch(error => {
          console.log(error)
          isLoading.value = false
        })
      }

      const attachment = reactive({
        id: '',
        comboard_id: '',
        file_1: '',
      })

      const getBase64 = (attach) => {
        axios
        .get('/comboard-attachment', {
        params: {
          comboard_id: attach,
          download: true
        }
        })
        .then(response => {
          attachment.value = response.data.data
        })
      }
      // Parent
      const store = (index, env) => {
        const url = props.showEdit ? 'comboard-detail/' + inputComment.id : 'comboard-detail'
        const method = props.showEdit ? 'PUT' : 'POST'
        if (method === 'POST') {
          inputComment.created_by = localStorage.getItem('username')
        } else {
          inputComment.updated_by = localStorage.getItem('username')
        }

        const dataSubmit = reactive({
          name: userLogin,
          comment: commentParent.comment_input[env],
          comboard_id: index,
          created_by: localStorage.getItem('username'),
        })

        axios({
          method,
          url,
          params: dataSubmit
        })
        .then(response => {
          if (response.data.success) {
            toast.success(response.data.message)
            refresh2()
            reset()
          } else {
            errors.value = response.data.messages
            toast.error(response.data.messages)
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error)
            toast.error(error.response.message)
            console.log(JSON.stringify(error.request))
          } else if (error.message) {
            console.log(error.message)
            toast.error(error.message)
            console.log(JSON.stringify(error.message))
          }
        })
      }

      // Child
      const store2 = (index, cid) => {
        const url = props.showEdit ? 'comboard-detail/' + parentChild.id : 'comboard-detail'
        const method = props.showEdit ? 'PUT' : 'POST'
        if (method === 'POST') {
            parentChild.created_by = localStorage.getItem('username')
        } else {
            parentChild.updated_by = localStorage.getItem('username')
        }

        const dataChildSubmit = reactive({
          comboard_id: cid,
          comment: parentChild.comment_detail[index],
          name: userLogin,
          created_by: localStorage.getItem('username'),
          detail_id: index,
          reply: parseInt(parentChild.reply_detail[index]) + 1,
          head_id: parentChild.reply_head[index]
        })

        // parentChild.name = userLogin
        // parentChild.reply = parseInt(parentChild.reply_detail[index]) + 1
        // parentChild.comment = parentChild.comment_detail[index]
        // parentChild.comboard_id = cid
        // parentChild.detail_id = index
        // parentChild.head_id = parentChild.reply_head[index]

        // parentChild.comboard_id = homeObject.value

        parentChild.id = parentChild2.id
        axios({
        method,
        url,
        params: dataChildSubmit
        })
        .then(response => {
          if (response.data.success) {
            toast.success(response.data.message)
            refresh2()
          } else {
            errors.value = response.data.messages
            toast.error(response.data.messages)
          }
          parentChild.comment_detail[index] = ''
        })
        .catch(error => {
          if (error.response) {
              console.log(error)
              toast.error(error.response.message)
              console.log(JSON.stringify(error.request))
          } else if (error.message) {
              console.log(error.message)
              toast.error(error.message)
              console.log(JSON.stringify(error.message))
          }
        })
      }

      const detailInfo = (item) => {
        homeObject.value = item
        getBase64(item)
      }

      const showComment = (index) => {
        commentClickId.value = index
      }

      const hideModal2 = () => {
        detailChild.value = false
        refresh2()
      }

      const showModal2 = () => {
        detailChild.value = !detailChild.value
      }

      const addChild = (item) => {
        showModal2()
        childObject.value = item
      }

      const role = () => {
        const user_parent = localStorage.getItem('user_id')
        axios
        .get('comboard-role', {
            params: {
              user_parent_id: user_parent
            }
          })
        .then(response => {
          localStorage.setItem('roleComboard', response.data.data)
        })
        .catch((error) => {
          toast.error(error.data.message)
        })
      }

      const checkUserLogin = () => {
        // isLoading.value = true
        const user = localStorage.getItem('user_id')
        const loginAs = 'parent'
        const url = 'check-user-login'
        const method = 'GET'
        axios({
          method,
          url,
          params: {
            user_id: user,
            login_as: loginAs
          }
        })
        .then(response => {

          if(response.data.data < 1){
            localStorage.clear()
            router.push('/login-parent')

            // isLoading.value = false
          }
        })
        .catch(error => {
          console.log('error user', error)
          // localStorage.clear()
          router.push('/login-parent')
          // isLoading.value = false
        })
      }

      const comboardsPriority = reactive([])
      const getComboardsPriority = () => {
        isLoading.value = true
        const user_parent = localStorage.getItem('user_id')
        const loginAs = 'parent'
        const url = 'comboard-priority'
        const method = 'GET'

        axios({
          method,
          url,
          params: {
            user_parent_id: user_parent,
            login_as: loginAs,
            skip: comboards.skip
          }
        })
        .then(response => {
          comboardsPriority.value = response.data.data
          // isLoading.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      const scrollToElement = (env) => {
        const no = parseInt(env)-2
        const element = document.getElementById('comboardlistid'+no);

        if (element) {
          // Lakukan scroll ke elemen
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };
      const showPriority = (item) => {
        isLoading.value = true
        const user_parent = localStorage.getItem('user_id')
        const loginAs = 'parent'
        const url = 'comboard-priority-link'
        const method = 'GET'

        axios({
          method,
          url,
          params: {
            user_parent_id: user_parent,
            login_as: loginAs,
            skip: comboards.skip,
            comboard_id: item
          }
        })
        .then(response => {
          isLoading.value = false

          comboards.page = response.data.page
          comboards.skip = response.data.skip
          comboards.value = response.data.data

          setTimeout(() => {
            scrollToElement(response.data.urut)
          }, 1000)
        })
        .catch(error => {
          isLoading.value = false
          console.log(error)
        })
      }


      onMounted(() => {
        checkUserLogin()
        getDate()
        getComboardsPriority()

        if (localStorage.getItem('reloaded')) {
          localStorage.removeItem('reloaded')
        } else {
          localStorage.setItem('reloaded', '1')
          // location.reload()
        }
        refresh()
        setInterval(() => {
          refresh2()
        }, 85000)
        // role()
        // refresh2()

        window.addEventListener('scroll', handleScroll)
      })

      const srollTransform = ref(false)
      const dataOffset = ref(0)

      const handleScroll = (event) => {
        if(window.scrollY >= 260){
          srollTransform.value = true
        } else {
          srollTransform.value = false
        }

        let leftmenu = document.getElementById('leftFixed')
        let rightmenu = document.getElementById('rightFixed')
        let value = window.scrollY

        if(leftmenu && rightmenu){
          if (value >= 80) {
            leftmenu.style.top = '70px'
            rightmenu.style.top = '70px'
          } else {
            leftmenu.style.top = '80px'
            rightmenu.style.top = '80px'
          }
        }
      }

      onBeforeMount(() => {})

      watchEffect(() => {
        const newComments = homeObject.value
        const id = newComments.id
        idValueComment.value = id
        Object.assign(comment2, newComments)
        // refresh2()

        const newChild = childObject.value
        const id1 = newChild.id
        idValueChild.value = id1
        Object.assign(parentChild2, newChild)
        // refresh3()
      })

      const showid = (item, value) => {
        let num = value
        if (value === null) {
          num = 0
        }
        parentChild.reply_detail[item] = num
        if (comboards.show_id === item) {
          comboards.show_id = ''
        } else {
          comboards.show_id = item
        }
      }

      const showdetailid = (item, value, data) => {
        deleteComboards.value = value
        let num = value
        if (value === null) {
          num = 0
        }
        parentChild.reply_detail[item] = num
        parentChild.reply_head[item] = data
        if (comboards.show_detail_id === item) {
          comboards.show_detail_id = ''
        } else {
          comboards.show_detail_id = item
        }
      }

      const forDate = (dateString) => {
        return dayjs(dateString).format('D MMM YYYY | HH:mm');
      }

      const formatFullDate = (index) => {
          return dayjs(index).format('DD MMMM YYYY');
      }

      const formatDate = (index) => {
          return dayjs(index).format('DD');
      }

      const formatNumDate = (index) => {
          return dayjs(index).format('YYYY-MM-DD');
      }

      const formatDateMonth = (index) => {
          return dayjs(index).format('DD MMM');
      }

      const formatHalfMonth = (index) => {
          return dayjs(index).format('DD MMM YYYY');
      }

      const formatMonth = (index) => {
          return dayjs(index).format('MMMM YYYY');
      }

      const formatDay = (index) => {
          return dayjs(index).format('dddd');
      }

      const formatDayMonth = (index) => {
          return dayjs(index).format('MMMM');
      }

      const formatTime = (index) => {
          return dayjs(index).format('HH:mm');
      }

      const dateNow = ref('')
      const dateYes = ref('')
      const dateWeek = ref('')
      const getDate = () => {
          var MyDate = new Date();

          dateWeek.value = MyDate.getFullYear() + '-'
                      + ('0' + (MyDate.getMonth()+1)).slice(-2) + '-'
                      + ('0' + (MyDate.getDate()-6)).slice(-2)
                      + ' 00:00:59';

          dateYes.value = MyDate.getFullYear() + '-'
                      + ('0' + (MyDate.getMonth()+1)).slice(-2) + '-'
                      + ('0' + (MyDate.getDate()+1)).slice(-2)
                      + ' 00:00:59';

          dateNow.value = MyDate.getFullYear() + '-'
                      + ('0' + (MyDate.getMonth()+1)).slice(-2) + '-'
                      + ('0' + MyDate.getDate()).slice(-2)
                      + ' 00:00:59';
      }

      // const modalMore = ref(false)

      const modalChat = ref(false)

      const thisCar = ref(0)

      const btnNextCar = (num, item) => {
        thisCar.value += +num
        !isNaN(thisCar.value) && thisCar.value > (-item.length) ? thisCar.value : (thisCar.value = (-item.length))
      }

      const btnPrevCar = (num) => {
        thisCar.value -= -num
        !isNaN(thisCar.value) && thisCar.value < 0 ? thisCar.value : (thisCar.value = 0)
      }

      const longText = ref('test')

      const showDesc = (index) => {
        if((longText.value === 'test') || (longText.value !== index)) {
          longText.value = index
        } else {
          longText.value = 'test'
        }
      }

      const modalComboard = ref(false)
      const dataCom = ref({})

      const openComment = (index) => {
        comboards.modalMore  = index.id
        if(comboards.modalMore === index.id) {
          modalComboard.value = true
        } else {
          modalComboard.value = false
        }
        dataCom.value = index

        if(modalComboard.value === true) {
          document.html.style.overflowY = 'hidden !important'
        } else {
          document.html.style.overflowY = 'auto'
        }
      }

      // Period
      const mySubmitFunction = () => {
        return false;
      }
      const modalSetPeriod = ref(false)
      const valueDailyObject = ref({})
      const valueDaily = reactive({
        firstWeek: "",
        lastWeek: ""
      });
      const searchPeriod = () => {
        console.log('valueDaily HOME', valueDaily)
        valueDailyObject.value = valueDaily
        modalSetPeriod.value = false
      }


      const openText = ref('none')
      const showText = (id) => {
        if((openText.value === 'none') || (openText.value != id)) {
          openText.value = id
        } else {
          openText.value = 'none'
        }
      }

      const openImgDetail = ref(false)
      const dataImgDetail = reactive({
        img: '',
        alt: ''
      })
      const openImg = (img, alt) => {
        if(openImgDetail.value === false) {
          openImgDetail.value = true
          dataImgDetail.img = img
          dataImgDetail.alt = alt
        } else {
          openImgDetail.value = false
          dataImgDetail.img = ''
          dataImgDetail.alt = ''
        }
      }

      return {
        searchPeriod,
        mySubmitFunction,
        modalSetPeriod,
        valueDaily,
        valueDailyObject,
        openText,
        showText,
        comboardsPriority,
        getComboardsPriority,
        showPriority,
        download,
        downloadDoc,
        openComment,
        dataCom,
        modalComboard,
        dateNow,
        dateYes,
        dateWeek,
        getDate,
        loadingComboard,
        inputComment,
        showComp,
        detailObject,
        modalWeek,
        detailClickWeek,
        closeClick,
        modalInv,
        detailClickInv,
        detailClickPay,
        closePay,
        modalPay,
        closeInv,
        forDate,
        dayjs,
        role,
        showid,
        filterData,
        showdetailid,
        mdiArrowDownDropCircle,
        mdiMenuDown,
        mdiClose,
        mdiSend,
        mdiCircleSmall,
        titleStack,
        comboards,
        detailModal,
        // deletePost,
        deletePostComment,
        deleteModal,
        hideModal,
        hideModal2,
        childModal,
        showModal,
        detailInfo,
        addChild,
        homeObject,
        childObject,
        str,
        store,
        store2,
        reset,
        toast,
        errors,
        router,
        comment2,
        commentParent,
        parentChild,
        parentChild2,
        rowData,
        slides,
        isLoading,
        commentClickId,
        showComment,
        getBase64,
        confirm,
        cancel,
        // confirmDelete,
        confirmDeleteComment,
        attachment,
        userLogin,
        usernameLogin,
        checkUser,
        userCheck,
        userRole,
        srollTransform,
        // modalMore,
        btnPrevCar,
        btnNextCar,
        thisCar,
        modalChat,
        modDelPick,
        datadel,
        messDel,
        showReason,
        dataReason,
        showModalReason,
        dataOffset,
        formatFullDate,
        formatDate,
        formatNumDate,
        formatDateMonth,
        formatHalfMonth,
        formatMonth,
        formatDay,
        formatDayMonth,
        formatTime,
        longText,
        showDesc,
        openImgDetail,
        dataImgDetail,
        openImg
      }
    },

    methods: {
      nextSlide() {
          this.slideCount = this.$el.inner.length;
          this.currentIndex = (this.currentIndex + 1) % this.slideCount;
      },

      prevSlide() {
          this.slideCount = this.$el.inner.length;
          this.currentIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
      },

      clearForm () {
        this.attachment = reactive({
          id: '',
          comboard_id: '',
          file_1: '',
          created_at: '',
          created_by: '',
          updated_at: '',
          updated_by: ''
        })
      },

      logOutput (outputData) {
      },

      handleClick (event, ref) {
        this.$refs[ref][event]()
      },

      handleSearch (e, platform) {
        if (platform === 'youtube') {
          this.youtubeLink = e.target.value
        } else {
          this.vimeoLink = e.target.value
        }
      }
    },

    computed: {
      cssVars () {
        return {
          '--datato-x': this.thisCar
        }
      }
    }
  })
</script>


<style lang="scss">
  @import '../../css/parent.scss';
  @import '../../css/comboardAdmin.scss';

  .carousel-container {
    transform: translateX(calc(var(--datato-x) * (100vw - 20px)));

    @media (min-width: 480px) {
      transform: translateX(calc(var(--datato-x) * (100vw - 40px)));
    }

    @media (min-width: 768px) {
      transform: translateX(calc(var(--datato-x) * 700px));
    }
  }

  .modal-image {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 50 !important;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(2px);
    transition: opacity .5s;
    padding: 50px 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .close-image {
      width: 100%;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .prev-image {
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 80vh;
      transition: transform 1s;
      position: relative;
      z-index: 2;

      .close-btn {
        width: 32px;
        height: 32px;
        position: absolute;
        top: -20px;
        right: -32px;
        cursor: pointer;

        svg {
          width: 24px;
          height: 24px;

          path {
            stroke: white;
          }
        }
      }

      img {
        width: auto;
        height: auto;
        max-width: 800px;
        max-height: 80vh;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
      }
    }
  }
  .open-modal-image {
    opacity: 100%;
    pointer-events: all;

    .prev-image {
      transform: scale(1);
    }
  }
  .hide-modal-image {
    opacity: 0;
    pointer-events: none;

    .prev-image {
      transform: scale(0);
    }
  }
</style>
